import { apiSend, getRoute } from "@services/axios";

// Registration
export const registerUser = async (formData) => {
  const response = await apiSend(getRoute("register"), "post", formData);
  return response.data;
};

// Login
export const loginUser = async (email, password) => {
  const response = await apiSend(getRoute("auth"), "post", { email, password });
  console.log("Login response:", response);
  return response.data.result;
};

// Verify code
export const verifyCode = async (token, tempToken) => {
  const response = await apiSend(tempToken, "post", {
    token,
  });
  console.log("Verify code response:", response);
  return response.data;
};

// Logout
export const logoutUser = async () => {
  try {
    logOut();
    // Clear all local and session storage
    localStorage.clear();
    sessionStorage.clear();

    console.log("App storage cleared successfully!");
  } catch (error) {
    console.error("Error clearing storage:", error);
  }
};

// Forgot password
export const forgotPassword = async (email) => {
  const response = await apiSend(getRoute("forgot_password"), "post", {
    email,
  });
  return response.data;
};

export const setToken = (value) => {
  return {
    type: "TOKEN",
    payload: value,
  };
};

export const setLogedType = (value) => {
  return {
    type: "LOGGEDTYPE",
    payload: value,
  };
};

export const setData = (value) => {
  return {
    type: "data",
    payload: value,
  };
};
export const setProvider = (value) => {
  return {
    type: "provider",
    payload: value,
  };
};
export const setIsLogged = (value) => {
  return {
    type: "LOGGED",
    payload: value,
  };
};
export const setMode = (value) => {
  return {
    type: "MODE",
    payload: value,
  };
};
export const setLang = (value) => {
  return {
    type: "LANG",
    payload: value,
  };
};

export const logOut = () => {
  return {
    type: "LOGOUT",
  };
};

export const setLoggedAt = () => {
  return {
    type: "LOGGED_AT",
    payload: new Date(Date.now()).toJSON(),
  };
};
